import { Controller } from "@hotwired/stimulus"
import axios from "axios"

export default class extends Controller {
  static targets = ["list", "input"]
  static values = {
    parentUrl: String,
    url: String
  }

  connect() {
    console.log("todos!!!!!!")
  }

  checkBoxChanged(event) {
    const url = event.target.dataset.url
    console.log(url)
    axios.patch(url, JSON.stringify({
      todo: {
        closed: event.target.checked
      }
    }), {
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest"
      }
    })
  }

  addTodo(_event) {
    // dajemy chwile turbo do przetworzenia formularza
    setTimeout(() => {
      this.inputTarget.value = ""
    }, 100)
  }
}
